import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { IAppState } from '../../../../models/reduxState';
import { isNonAgaveSelector, isTeamsSelector, sourceAppSelector } from '../../../app/selectors/contactUsSelector';
import { PhoneField } from '../../presentationalComponents/RequestDetails/PhoneField';
import { dispatchUpdateRequest, dispatchUpdateIsPhoneNumberValid } from '../../reduxUpdater/dispatchers/requestDispatchers';
import { isPhoneEditingModeSelector, isPhoneNumberValidSelector } from '../../reduxUpdater/selectors/commonSelectors';
import {
  isRequestDetailsEditModeSelector,
  phoneFieldPlaceHolderSelector,
  twoDigitCountryCodeSelector,
  userCountryDialingCodeSelector,
  userPhoneSelector,
  userPhoneWithoutDialingCodeSelector,
} from '../../reduxUpdater/selectors/requestSelector';
import { regionInfoSelector } from '../../reduxUpdater/selectors/sharedStateSelectors';
import { getRequestDetailsStyles } from '../../styles/requestDetailsStyles';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  return {
    isPhoneEditingMode: isPhoneEditingModeSelector(state),
    isPhoneNumberValid: isPhoneNumberValidSelector(state),
    isRequestDetailsEditMode: isRequestDetailsEditModeSelector(state),
    phoneFieldPlaceHolder: phoneFieldPlaceHolderSelector(state),
    regionInfo: regionInfoSelector(state),
    sourceApp: sourceAppSelector(state),
    twoDigitCountryCode: twoDigitCountryCodeSelector(state),
    userCountryDialingCode: userCountryDialingCodeSelector(state),
    userPhoneWithoutDialingCode: userPhoneWithoutDialingCodeSelector(state),
    userPhone: userPhoneSelector(state),
    isNonAgave: isNonAgaveSelector(state),
    isTeams: isTeamsSelector(state)
  };
};

const mapDispatchToProps = {
  dispatchUpdateRequest,
  dispatchUpdateIsPhoneNumberValid,
};

export const PhoneFieldContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(PhoneField, getRequestDetailsStyles));
